<template>
  <section>
    <div v-if="questions.length > 0" class="p-4 flex flex-col gap-8">
      <div
        class="flex flex-col w-full bg-white p-4 pb-8 rounded-b-md border-b-4 border-h-primary-500 py-4 min-h-[100px] gap-8 shadow-md"
        v-for="(question, i) in questions"
        :key="i"
      >
        <div class="w-full flex justify-between">
          <div class="w-[80%]">
            <p class="font-[800]">{{ question?.prompt }}</p>
          </div>
          <div class="flex justify-center items-center gap-2">
            <p>{{ $t("labels.generic", { pt: "Questão: ", en: "Question: " }) }}</p>
            <div
              class="bg-h-info-100 flex justify-center items-center p-1 px-4 rounded-xl text-h-primary-500"
            >
            {{ $t("labels.generic", { pt: "Aberta", en: "Open" }) }}
            </div>
          </div>
        </div>
        <div
          class="flex flex-col gap-4 lg:flex-row"
          v-for="(item, j) in question.items"
          :key="j"
        >
          <div
            class="w-full lg:w-[25%] min-w-[200px] gap-2 flex flex-row-reverse lg:flex-row justify-end lg:justify-start items-center"
          >
            <div class="w-[20px] h-[40px] flex items-center justify-center">
              <v-icon
                name="hi-solid-check-circle"
                class="text-[#74B543]"
                v-if="item.itemId === question.correctItemId"
              ></v-icon>
            </div>
            <div class="w-[180px]">
              <p class="line-clamp-2">{{ item.answerText }}</p>
            </div>
          </div>
          <div class="w-full flex flex-col gap-8">
            <div
              class="h-[40px] w-full bg-h-neutral-200 flex rounded-md overflow-auto overflow-x-hidden"
            >
              <div
                v-if="item.choseTimes && item.choseTimes > 0"
                :class="`flex justify-end p-4 items-center h-[40px] ${getBackground(
                  item?.itemId,
                  question.correctItemId
                )} rounded-l-md`"
                :style="`width:${item.percentage}%`"
              >
                <p class="text-sm" v-if="item.percentage > 17">
                  {{ item.choseTimes }} ({{ item.percentage }}%)
                </p>
              </div>
              <div
                class="w-full h-[40px] flex items-center p-4"
                v-if="item.choseTimes === 0 || item.percentage < 17"
              >
                <p class="text-sm">{{ item.percentage }}%</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="p-8">
      <EmptyData
        :data="questions.length == 0"
        :title="`${$t('labels.generic', {
          pt: 'Dados não encontrados',
          en: 'titleEN',
        })}`"
        :label="`${$t('labels.generic', {
          pt: 'Os dados gerados pelas respostas dos quizzes ficarão aqui.',
          en: 'titleEN',
        })}`"
        :image="'waiting_object.svg'"
        imgSize="h-40"
      />
    </div>
  </section>
</template>

<script lang="ts">
import { PropType, defineComponent } from "vue";
import { QuestionsObjectiveStats } from "@/models/stats.model";

export default defineComponent({
  name: "quizAnswer",
  data() {
    return {};
  },
  props: {
    questions: {
      type: Array as PropType<any>,
      default: [],
    },
  },
  mounted() {},
  methods: {
    getBackground(idItem: any, idCorrectAnswer: any): string {
      let result = "bg-h-error-400 text-white";
      if (idItem === idCorrectAnswer) {
        result = "bg-[#74B543] text-black";
      }
      return result;
    },
  },
});
</script>
